<script>
    import { link } from "svelte-routing";
    import { onDestroy } from "svelte";
    import { settings } from "../../stores/settingsStore";
    import { selectedActiveYear } from "../../stores/selectedActiveYear";
    import { isRootManager, isAdmin, isGroupManager } from "../../stores/settingsStore";

    export let location;
    let collapseShow = "hidden";
    const minYear = 2017;
    let selectYears = [];

    function toggleCollapseShow(classes) {
        collapseShow = classes;
    }

    const unsubscribeSettings = settings.subscribe((data) => {
        if (!data){
            return;
        }

        const actualYear = new Date().getFullYear();
        const maxYear = actualYear > data.subscriptionActiveYear ? actualYear : data.subscriptionActiveYear;

        selectYears = Array(maxYear - minYear + 1).fill(null).map((_, i) => ({ value: i + minYear, label: i + minYear }))
    });

    onDestroy(unsubscribeSettings);
</script>

<nav class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap
    md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-50 py-4 px-6">
	<div class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0
     flex flex-wrap items-center justify-between w-full mx-auto">
		<!-- Toggler -->
		<button class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded
             border border-solid border-transparent"
            type="button"
            on:click={()=> toggleCollapseShow('bg-white m-2 py-3 px-6')}
        >
            <i class="fas fa-bars"></i>
		</button>
		<!-- Brand -->
		<a
            use:link
            class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase
            font-bold p-4 px-0" href="/">
            Sinistra italiana
        </a>
		<!-- Collapse -->
		<div class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow
         absolute top-0 left-0 right-0 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded {collapseShow}">
			<!-- Collapse header -->
			<div class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
				<div class="flex flex-wrap">
					<div class="w-6/12">
						<a
                            use:link
                            class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap
                             text-sm uppercase font-bold p-4 px-0" href="/">
                            Sinistra italiana
                        </a>
					</div>
					<div class="w-6/12 flex justify-end">
						<button
                            type="button"
                            class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none
                            bg-transparent rounded border border-solid border-transparent"
                            on:click={()=> toggleCollapseShow('hidden')}
                        >
                            <i class="fas fa-times"></i>
						</button>
					</div>
				</div>
			</div>
			<!-- Forms -->
			<form class="mt-6 mb-4 md:hidden">
				<div class="mb-3 pt-0">
					<input
                        type="text"
                        placeholder="Search"
                        class="border-0 px-3 py-2 h-12 border border-solid border-blueGray-500
                         placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug
                          shadow-none outline-none focus:outline-none w-full font-normal"
                    />
				</div>
			</form>
			<hr class="md:min-w-full my-4" />
			<!-- Heading -->
			<h6 class="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
                Anno di riferimento
            </h6>
            {#if selectYears.length > 0}

                <select bind:value={$selectedActiveYear} class="input-home outline-none h-10 focus:outline-none w-full">
                    {#each selectYears as item, i}
                        <option key={i} value={item.value}>{item.label}</option>
                    {/each}
                </select>
            {/if}

			<!-- Divider -->
			<hr class="my-4 md:min-w-full" />
			<!-- Heading -->
			<h6 class="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
                Sezioni utenti
            </h6>
			<!-- Navigation -->
			<ul class="md:flex-col md:min-w-full flex flex-col list-none">
				<li class="items-center">
					<a
                        use:link
                        href="/admin/subscribers/table"
                        class="text-xs uppercase py-3 font-bold block {location.href.indexOf('/admin/subscribers') !== -1 ? 'text-red-500 hover:text-red-600':'text-blueGray-700 hover:text-blueGray-500'}"
                    >
						<i class="fas fa-user-plus mr-2 text-sm {location.href.indexOf('/admin/subscribers/') !== -1 ? 'opacity-75' : 'text-blueGray-300'}"></i>
                            Iscritti
					</a>
				</li>

                {#if $isRootManager || $isAdmin}
                    <li class="items-center">
                        <a
                            use:link href="/admin/prints/?"
                            class="text-xs uppercase py-3 font-bold block
                                {location.href.indexOf('/admin/prints') !== -1 ? 'text-red-500 hover:text-red-600':'text-blueGray-700 hover:text-blueGray-500'}"
                        >
                            <i class="fas fa-print mr-2 text-sm {location.href.indexOf('/admin/prints/') !== -1 ? 'opacity-75' : 'text-blueGray-300'}"></i>
                                Stampe
                        </a>
                    </li>
                {/if}
			</ul>

			<hr class="my-4 md:min-w-full" />
			<h6 class="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
                Sezioni admin
            </h6>

			<ul class="md:flex-col md:min-w-full flex flex-col list-none">
                {#if $isAdmin}
                    <li class="items-center">
                        <a
                            use:link
                            href="/admin/users/table"
                            class="text-xs uppercase py-3 font-bold block
                            {location.href.indexOf('/admin/users') !== -1 ? 'text-red-500 hover:text-red-600':'text-blueGray-700 hover:text-blueGray-500'}"
                        >
                            <i class="fas fa-user-lock mr-2 text-sm {location.href.indexOf('/admin/users/') !== -1 ? 'opacity-75' : 'text-blueGray-300'}"></i>
                            Utenti
                        </a>
                    </li>
                {/if}

                {#if $isAdmin || $isGroupManager}
                    <li class="items-center">
                        <a
                            use:link
                            href="/admin/groups/table"
                            class="text-xs uppercase py-3 font-bold block {location.href.indexOf('/admin/groups') !== -1 ? 'text-red-500 hover:text-red-600':'text-blueGray-700 hover:text-blueGray-500'}"
                        >
                            <i class="fas fa-layer-group mr-2 text-sm {location.href.indexOf('/admin/groups/') !== -1 ? 'opacity-75' : 'text-blueGray-300'}"></i>
                            Gruppi
                        </a>
                    </li>
                {/if}

                {#if $isAdmin}
                    <li class="items-center">
                        <a
                            use:link
                            href="/admin/jurisdiction/table"
                            class="text-xs uppercase py-3 font-bold block {location.href.indexOf('/admin/jurisdiction') !== -1 ? 'text-red-500 hover:text-red-600':'text-blueGray-700 hover:text-blueGray-500'}"
                        >
                            <i class="fas fa-gavel mr-2 text-sm {location.href.indexOf('/admin/jurisdiction/') !== -1 ? 'opacity-75' : 'text-blueGray-300'}"></i>
                            Sottogruppi
                        </a>
                    </li>
                {/if}

                {#if $isAdmin}
                    <li class="items-center">
                        <a
                        use:link
                        href="/admin/settings/"
                        class="text-xs uppercase py-3 font-bold block {location.href.indexOf('/admin/settings') !== -1 ? 'text-red-500 hover:text-red-600':'text-blueGray-700 hover:text-blueGray-500'}"
                    >
                        <i class="fa fa-wrench fa-gears mr-2 text-sm {location.href.indexOf('/admin/settings/') !== -1 ? 'opacity-75' : 'text-blueGray-300'}"></i>
                            Impostazioni globali
                        </a>
                    </li>
                {/if}
			</ul>
		</div>
	</div>
</nav>
